const state = {
    privilege_list: [],
    selected_role: '',
    privileges_selected_left: [],
    privileges_selected_right: []
  }
  
  export default state
  


//////////////////
// WEBPACK FOOTER
// ./state/privilege/privilege.state.js
// module id = null
// module chunks = 